import React from "react";
import { useTranslation } from "react-i18next";

import { FireworksAnim } from "../../animations/Animations";
import TestIds from "../../testIds";
import { ConfirmationDialog } from "../dialog/ConfirmationDialog";
import {
    PurchaseFinishedContentWrapper,
    PurchaseFinishedDescription,
    PurchaseFinishedImageWrapper,
    PurchaseFinishedTitle
} from "./PurchaseWizard.styles";
import { PurchaseDialogPaymentType } from "./PurchaseWizardDialog.utils";

interface IProps {
    type: PurchaseDialogPaymentType;
    onClose: () => void;
}

const PurchaseFinishedDialog: React.FC<IProps> = (props: IProps) => {
    const { type, onClose } = props;
    const { t } = useTranslation(["Subscriptions"]);
    const isCard = type === PurchaseDialogPaymentType.Card;

    return (
        <ConfirmationDialog onConfirm={onClose}
                            onClose={null}
                            confirmText={t(`Subscriptions:ProductSelection.${isCard ? "PaymentCardFinishedConfirmButton" : "PaymentWireFinishedConfirmButton"}`)}
                            width={"400px"}
                            height={"340px"}
        >
            <PurchaseFinishedContentWrapper>
                <PurchaseFinishedTitle data-testid={TestIds.Title}>
                    {t(`Subscriptions:ProductSelection.${isCard ? "PaymentCardFinishedTitle" : "PaymentWireFinishedTitle"}`)}
                </PurchaseFinishedTitle>
                <PurchaseFinishedDescription data-testid={TestIds.Description}>
                    {t(`Subscriptions:ProductSelection.${isCard ? "PaymentCardFinishedDescription" : "PaymentWireFinishedDescription"}`)}
                </PurchaseFinishedDescription>
                <PurchaseFinishedImageWrapper>
                    <FireworksAnim/>
                </PurchaseFinishedImageWrapper>
            </PurchaseFinishedContentWrapper>
        </ConfirmationDialog>
    );
};

export default PurchaseFinishedDialog;